import { render } from "./ISPPackage.vue?vue&type=template&id=143519e4&scoped=true"
import script from "./ISPPackage.vue?vue&type=script&lang=js"
export * from "./ISPPackage.vue?vue&type=script&lang=js"

import "./ISPPackage.vue?vue&type=style&index=0&id=143519e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143519e4"]])

export default __exports__